import {useSelector} from 'react-redux';

import BadgesGrid from '@/components/BadgesGrid/BadgesGrid';
import {selectInProgressBadges} from '@/state/selectors/loyalty';
import type {BadgesInProgressCollectionSectionContentModel} from '@/types/content';

type BadgesInProgressCollectionSectionProps = {
    content?: BadgesInProgressCollectionSectionContentModel | null;
};

const BadgesInProgressCollectionSection = ({content}: BadgesInProgressCollectionSectionProps) => {
    const inProgressBadges = useSelector(selectInProgressBadges);
    const {actionsRemainingPluralForms} = content ?? {};

    return (
        <BadgesGrid
            className='mt-2'
            badges={inProgressBadges}
            showProgress
            actionsRemainingPluralForms={actionsRemainingPluralForms ?? undefined}
        />
    );
};

export default BadgesInProgressCollectionSection;
